<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <h1 v-translate>Rozlišení</h1>
      </div>

      <app-table
          clickable
          deletable
          :data="items"
          highlight-rows-on-hover
          @deleteRow="deleteItem"
          :loading="listLoading"
      >
        <template slot="secondary_header">
          <div class="status search">
            <a
                class="add add_expand"
                :class="{'open': isOpen}"
                @click.prevent="toggleExpandContent"
                title="Přidat párovací šablonu"
            >Přidat párovací šablonu</a>
          </div>

          <form class="filter expand_content" :class="{ 'open': isOpen }" @submit.prevent="submitForm">
            <div class="field_left">
              <app-input
                  required
                  id="name"
                  name="name"
                  :label="translations.name"
                  inputSize="255"
                  type="text"
                  v-model.trim="name"
              />
            </div>
            <div class="field_right">
              <app-input
                  required
                  id="resolution"
                  name="resolution"
                  :label="translations.resolution"
                  inputSize="255"
                  type="number"
                  v-model.trim="resolution"
              />
              <p class="field">
                <app-content-save-button />
              </p>
            </div>
          </form>
        </template>

        <app-table-column first attribute="name" :label="translations.name" />
        <app-table-column attribute="resolution" :label="translations.resolution" />
        <app-table-column attribute="numberOfLoadedTvChannels" :label="translations.numberOfTvChannels" />
      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import { prop, length, compose } from 'ramda'
import { mapActions, mapState } from 'vuex'
import appTitleMixin from 'mixins/appTitleMixin'
import getItemsListMixin from 'mixins/getItemsListMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { showErrorWithTimeout } from '@/utils/form'
import { showDeleteDialog } from '@/utils/dialog'
import { DELETE } from '@/constants/api'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'VideoQualities',
  detailRouteName: 'VideoQuality'
})

export default {
  name: 'video-qualities',
  mixins: [itemsListMixin, appTitleMixin()],
  data() {
    return {
      isOpen: false,
      name: '',
      resolution: null
    }
  },
  computed: {
    translations() {
      return {
        name: this.$gettext('Název'),
        resolution: this.$gettext('Rozlišení'),
        numberOfTvChannels: this.$gettext('Počet TV kanálů')
      }
    },
    currentTitle() {
      return [
        this.$gettext('Rozlišení')
      ]
    }
  },
  methods: {
    ...mapActions([
      'createVideoQuality',
      'deleteVideoQuality'
    ]),
    shouldRefreshAfterDelete() {
      return true
    },
    getDeleteError(item) {
      if (item.numberOfLoadedTvChannels !== 0) {
        return this.$gettext('Rozlišení nelze smazat, protože je obsaženo v TV kanálech.')
      }
      return null
    },
    toggleExpandContent() {
      this.isOpen = !this.isOpen
    },
    async submitForm(e) {
      this.errors.clear()

      await this.$validator.validateAll()
      if (this.errors.items.length > 0) {
        this.appShowErrors(this.errors.items.map(v => v.msg))
        return
      }

      const { elements } = e.target
      const result = await this.createVideoQuality({
        data: {
          name: this.name,
          resolution: parseInt(this.resolution)
        }
      }).catch(err => err.response)

      if (result.status === 201) {
        e.target.reset()
        this.$validator.reset()
      }

      this.fetchItems()

      this.name = ''
      this.resolution = null
    }
  }
}
</script>
